import { useEffect, useState } from "react";
import "./MagicBandOverlays.css";

const WAKE_DURATION = 25;

const WakeOverlay = ({ onClose }) => {
  const [seconds, setSeconds] = useState(WAKE_DURATION);

  useEffect(() => {
    if (seconds <= 0) {
      onClose();
      return;
    }
    const timer = setTimeout(() => setSeconds((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds, onClose]);

  const progress = ((WAKE_DURATION - seconds) / WAKE_DURATION) * 100;

  return (
    <div className="mbo-backdrop">
      <div className="mbo-card mbo-wake">
        <div className="mbo-icon">💤</div>
        <h2 className="mbo-heading">Your band is asleep...</h2>
        <p className="mbo-body">
          Waking it up! This will take about {seconds} second
          {seconds !== 1 ? "s" : ""}.
        </p>
        <div className="mbo-progress-track">
          <div className="mbo-progress-bar" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  );
};

export default WakeOverlay;
